import { configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import en from "@vee-validate/i18n/dist/locale/en.json";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import th from "@vee-validate/i18n/dist/locale/th.json";

export function initVeeValidate() {
  // Updating default vee-validate configuration
  configure({
    validateOnBlur: true,
    validateOnChange: true,
    validateOnInput: true,
    validateOnModelUpdate: true,
    generateMessage: localize({
      en,
      th,
    }),
  });
}
